import { render, staticRenderFns } from "./AssignStaffScheduleModal.vue?vue&type=template&id=12089232&"
import script from "./AssignStaffScheduleModal.vue?vue&type=script&lang=js&"
export * from "./AssignStaffScheduleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12089232')) {
      api.createRecord('12089232', component.options)
    } else {
      api.reload('12089232', component.options)
    }
    module.hot.accept("./AssignStaffScheduleModal.vue?vue&type=template&id=12089232&", function () {
      api.rerender('12089232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/AssignStaffScheduleModal.vue"
export default component.exports